import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Anchor = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M19 13h-2v2h.913c-.435 2.47-2.443 4.471-4.913 4.906V13h2v-2h-2V9.336c1.543-.459 2.714-1.923 2.714-3.621C15.714 3.666 14.048 2 12 2S8.286 3.666 8.286 5.715c0 1.698 1.171 3.162 2.714 3.621V11H9v2h2v6.906C8.53 19.471 6.521 17.47 6.087 15H7v-2H5a1 1 0 0 0-1 1c0 3.998 3.115 7.416 7 7.927V22h2v-.073c3.885-.511 7-3.929 7-7.927a1 1 0 0 0-1-1zm-8.714-7.285C10.286 4.77 11.055 4 12 4s1.714.77 1.714 1.715c0 .951-.801 1.785-1.714 1.785s-1.714-.834-1.714-1.785z", key: "k0" })));
});
Anchor.displayName = 'Anchor';
export var AnchorDimensions = { height: 24, width: 24 };
